import React, { useState, useEffect } from "react";
import "./Template_1.css";

const Template_1_MainHeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const slides = [
    {
      image:
        "https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    },
    {
      image:
        "https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    },
    {
      image:
        "https://images.unsplash.com/photo-1426604966848-d7adac402bff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    },
  ];

  return (
    <div className="Template_1 main-hero-section">
      {/* Background Slides */}
      <div className="Template_1 background-slides">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`Template_1 slide ${
              currentSlide === index ? "Template_1 active" : ""
            }`}
            style={{ backgroundImage: `url(${slide.image})` }}
          ></div>
        ))}
      </div>

      {/* Text Overlay */}
      <div className="Template_1 text-overlay">
        <div
          className={`Template_1 content-inner ${
            isVisible ? "Template_1 visible" : ""
          }`}
        >
          <h1 className="Template_1 main-title">
            <span className="Template_1 title-line">Explore The</span>
            <span className="Template_1 title-line Template_1 accent">
              World's
            </span>
            <span className="Template_1 title-line">Hidden Treasures</span>
          </h1>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="Template_1 slide-indicators">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`Template_1 indicator ${
              currentSlide === index ? "Template_1 active" : ""
            }`}
            onClick={() => setCurrentSlide(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Template_1_MainHeroSection;
